import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getProtocolsTrack} from '../../services/getProtocolsTrack';
import {ConsultProtocolsTrackQueryProps} from './types';

export const useConsultProtocolsTrackQuery = ({
	registerNumber,
	enabled,
}: ConsultProtocolsTrackQueryProps) =>
	useQuery({
		queryKey: [QUERY_KEYS.CONSULT_PROTOCOLS, registerNumber],
		queryFn: ({signal}) => getProtocolsTrack({registerNumber, signal}),
		retry: 2,
		enabled,
	});
